export const PROFILE_HEADLINE =
    "Senior Data Engineer | Python, Rust, SQL | GCP, Cloud, DevOps | AI/ML | Scalable Systems & Architecture"

export const CONTACTS = {
    email: "me@wisl.dev",
    linkedinHref: "https://www.linkedin.com/in/wisl/",
    linkedinHandle: "/wisl",
    githubHref: "https://github.com/wislertt",
    githubHandle: "/wislertt",
    siteHref: "https://wisl.dev",
    siteLabel: "wisl.dev",
    location: "Bangkok, Thailand",
} as const

// suggested browser filename for the download — the owner's name beats a
// generic "resume.pdf" that collides with every other résumé in Downloads
export const DOWNLOAD_FILENAME = "resume-wisaroot.pdf"

// owner-only — the download gate. Client code must never import these:
// tree-shaking drops them from the bundle, and scripts/generate-pdfs.tsx
// greps dist/assets/*.js for the digits to fail the build if an import
// ever slips in.
export const OWNER_PHONE_CODE = "66"
export const OWNER_PHONE_REST = "971624939"
